import '../App.css';
import './Navbar.css';
import { Link } from "react-router-dom";

export default function Navbar()
{
    return(
        <header>
        <nav className="nav">
          <h2><Link to='/'>Carreras Documentadas</Link></h2>
          <ul className='JugadoresUl'>
            <Link to='/Jugadores/Messi'><li className='Messi'>Messi</li></Link>
            <Link to='/Jugadores/Ronaldo'><li className='Ronaldo'>Ronaldo</li></Link>
            <Link to='/Jugadores/Maradona' style={{display: "none"}}><li className='Maradona'>Maradona</li></Link>
            <Link to='/Jugadores/Pele'><li className='Pele'>Pelé</li></Link>
          </ul>
        </nav>
      </header>
    )
}

